import { useEffect, useState } from 'react';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Animates from 0 to `target` over `duration` ms with an ease-out curve.
 * Returns the current display value (an integer). Respects reduced-motion.
 */
const useCountUp = (target, duration = 700) => {
  const numericTarget = Number(target) || 0;
  const [value, setValue] = useState(prefersReducedMotion() ? numericTarget : 0);

  useEffect(() => {
    if (prefersReducedMotion() || numericTarget === 0) {
      setValue(numericTarget);
      return undefined;
    }

    let frame;
    const start = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(eased * numericTarget));
      if (progress < 1) {
        frame = requestAnimationFrame(tick);
      }
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [numericTarget, duration]);

  return value;
};

export default useCountUp;
